var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"close-btn",on:{"click":_vm.closeModal}},[_c('IconClose')],1),_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }